<template>
  <div class="flex flex-col items-center my-10 md:my-20">
    <div class="flex flex-col print:hidden">
      <h1
        class="text-xl md:text-3xl font-bold md:text-center leading-none mb-8"
      >
        Thank you, {{ customerName }}!
      </h1>
      <p class="text-sm md:text-base leading-loose md:text-center mb-10">
        Your claim has been sent to {{ agent }}. They will contact you if
        additional information is needed, and let you know the outcome of your
        claim.<br />
        You will receive an e-mail with contact details for {{ agent }} should
        you have any questions.
      </p>
    </div>

    <div class="flex justify-center lg:w-3/4 print:hidden">
      <MainButton
        title="Make another claim"
        gray
        medium
        shadow
        @click="newClaim"
      />
    </div>

    <hr class="my-10 border-t border-gray-400 lg:w-full print:hidden" />

    <div class="flex items-end justify-between my-6 w-full print:hidden">
      <h3 class="text-2xl font-medium leading-none">Summary</h3>
      <div>
        <MainButton title="Print" gray small @click="print">
          <Printer class="fill-current h-4 mr-1" />
        </MainButton>
      </div>
    </div>

    <div class="print:w-full">
      <FormSummary
        class="mb-8"
        :title="categoryTitle"
        :form="form.claim"
        :editable="false"
      />
      <CompensationSummary
        class="mb-8"
        title="Compensations"
        :form="compensations"
        :editable="false"
      />
      <FormSummary
        title="Bank Details"
        :form="form.bankDetails"
        :editable="false"
      />
      <Consents
        disabled
        checked
        :first-consent="true"
        :second-consent="false"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FormSummary from '@/components/Summary/FormSummary.vue';
import CompensationSummary from '@/components/Summary/CompensationSummary.vue';
import Consents from '@/components/Summary/Consents.vue';

export default {
  name: 'ThankYou',
  components: {
    FormSummary,
    CompensationSummary,
    Consents
  },
  data: () => ({
    firstConsent: false,
    secondConsent: false
  }),
  computed: {
    ...mapState({
      agent: (state) => state.claim.agent,
      customerName: (state) => state.customer.customer.firstName,
      category: (state) => state.claim.category,
      compensations: (state) => state.compensations.compensations,
      form: (state) => ({
        claim: state.form.claim,
        compensation: state.form.compensation,
        bankDetails: state.form.bankDetails
      })
    }),
    ...mapGetters(['categoryTitle'])
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'start'|| to.name === 'my-claim') {
      next();
    }
    else {
      this.dialogEndSession();
    }
  },
  mounted() {
    this.$store.commit('SET_PROGRESS', null);
  },
  methods: {
    newClaim() {
      this.$router.push({ name: 'my-claim' });
      this.scrollToTop();
    },
    print() {
      window.print();
    },
    dialogEndSession() {
      this.$dialog
        .confirm(
          {
            title: 'Go back',
            body:
              'Are you sure you want to leave this page? Doing so will end your session.'
          },
          { cancelText: 'Cancel' }
        )
        .then(function () {
            this.$store.commit('RESET_STATE');
            this.$router.push({ name: 'start' });
        });
    },
  }
};
</script>

<style lang="scss">
@media print {
  * {
    overflow: visible !important;
  }
}
</style>
